import { Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Avatar, Box, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { TestimonialAuthorProps as Props } from './types';

export const TestimonialAuthor = memo(
  ({
    name,
    role,
    company,
    avatar,
    badgeLabel,
    badgeColor,
    className,
  }: Props) => {
    return (
      <Box className={classnames('TestimonialAuthor', className)} sx={SX.root}>
        <Box sx={SX.userBlock}>
          <Avatar src={avatar} alt={name} size={40} />
          <Stack sx={SX.userText}>
            <Typography
              variant="body2"
              color="grey.700"
              fontWeight={700}
              noWrap
            >
              {name}
            </Typography>
            <Typography variant="body4" color="grey.500" noWrap>
              {role}, {company}
            </Typography>
          </Stack>
        </Box>
        <Label color={badgeColor} variant="soft" size="xsmall">
          {badgeLabel}
        </Label>
      </Box>
    );
  }
);

TestimonialAuthor.displayName = 'TestimonialAuthor';
